import { createAction, props } from '@ngrx/store';
import { SsoOidcDto } from '../dtos/ssoOidcDto.interface';

export const loadSsoProvider = createAction('[SSO] Load Provider', props<{ handle: string }>());

export const loadSsoProviderSuccess = createAction(
    '[SSO] Load Provider Success',
    props<{
        provider: SsoOidcDto;
    }>(),
);

export const loadSsoProviderFailure = createAction('[SSO] Load Provider Failure', props<{ error: any }>());
